import React from "react";
import { stats } from "../../data/content";
export function StatStrip() {
  return <section aria-label="Unit at a glance" className="border-y border-white/10 bg-navy-800" data-id="element-226" data-mp="12bfosm5cjogp">
      <ul className="container-x grid grid-cols-2 gap-px bg-white/10 px-0 sm:px-0 lg:grid-cols-4 lg:px-0" data-id="element-227" data-mp="neoyr3hkbp3r">
        {stats.map(stat => <li key={stat.label} className="bg-navy-800 px-3 py-7 text-center sm:px-4 sm:py-9 lg:py-12" data-id="element-228" data-mp="sc8b1xup9rt2">
            <span className="block font-display text-[clamp(2.2rem,4.4vw,3.6rem)] font-extrabold uppercase leading-none text-cyan" data-id="element-229" data-mp="eld2kmo45cq0">
              {stat.value}
            </span>
            <span className="mt-2.5 block text-[10px] font-bold uppercase leading-snug tracking-[0.14em] text-ice/80 sm:mt-3 sm:text-[12px] sm:tracking-[0.2em]" data-id="element-230" data-mp="4oqja2bfqtq3">
              {stat.label}
            </span>
          </li>)}
      </ul>
    </section>;
}